import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Tooltip } from "reactstrap";
import AuthContext from "../../Context/AuthContext";
import "../../../src/assets/css/home.css";
import { useCount } from "../../Context/CountContext";
import { eventService } from "../../api/eventService";
import { format, parseISO } from "date-fns";
import CommonPopUpModal from "../../components/Common/CommonPopUpModal";
import UserProfileIcon from "../../components/Common/UserProfileIcon";

export default function Header() {
	const [isSubNavOpen, setIsSubNavOpen] = useState(false);
	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const { user, logout, loading } = useContext(AuthContext);
	const navigate = useNavigate();
	const location = useLocation();
	const { cartCount, fetchCartCount } = useCount();
	const { enquiryCount, fetchEnquiryCount } = useCount();
	const defaultLedgerId = "00000000-0000-0000-0000-000000000000";
	const isLoggedIn = user?.LEDGER_ID !== defaultLedgerId;
	const [tooltipOpen, setTooltipOpen] = useState({});
	const [showLogoutDropdown, setShowLogoutDropdown] = useState(false);
	const dropdownRef = useRef(null);
	const triggerRef = useRef(null);
	const [open, setOpen] = useState(false);
	const [upcomingEvents, setUpcomingEvents] = useState([]);
	const [eloading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const guestDropdownRef = useRef(null);
	const guestTriggerRef = useRef(null);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

	useEffect(() => {
		fetchUpcomingEvents();
	}, []);

	const fetchUpcomingEvents = async () => {
		try {
			setLoading(true);
			const response = await eventService.GetDashboardEvent();
			const events = response.UpcomingEvent || [];
			setUpcomingEvents(events);
		} catch (err) {
			console.error('Error:', err);
			setUpcomingEvents([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (isLoggedIn) {
			fetchCartCount();
			fetchEnquiryCount();
		}
	}, [isLoggedIn]);

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				guestDropdownRef.current &&
				!guestDropdownRef.current.contains(event.target) &&
				guestTriggerRef.current &&
				!guestTriggerRef.current.contains(event.target)
			) {
				setOpen(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target) &&
				triggerRef.current &&
				!triggerRef.current.contains(event.target)
			) {
				setShowLogoutDropdown(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
		const onResize = () => setIsMobile(window.innerWidth <= 767);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	const toggleTooltip = (id) => {
		setTooltipOpen((prev) => ({ ...prev, [id]: !prev[id] }));
	};

	const toggleSubNav = () => setIsSubNavOpen(!isSubNavOpen);
	const closeSubNav = () => setIsSubNavOpen(false);
	if (loading) return null;

	const getNavItems = () => {
		const baseItems = [
			{ to: "/about-us", label: "ABOUT" },
			{ to: "/product-range", label: "PRODUCT RANGE" },
			{ to: "/services", label: "SERVICES" },
			{ to: "/catalogs", label: "CATALOGS" },
			{ to: "/vault-access", label: "VAULT ACCESS" },
			{ to: "/contact-us", label: "CONTACT US" },
			{ to: "/events", label: "EVENTS" },
			{ to: "/learn", label: "LEARN" },
		];
		return baseItems;
	};

	const navItems = getNavItems();

	const message = "You can always log back in any time."

	const handleLogout = () => {
		setShowLogoutModal(false);
		localStorage.setItem("GLOBAL_LOGOUT", Date.now().toString());
		logout();
		navigate("/login", { replace: true });
	};

	return (
		<>
			<header className="fixed-top">
				<div className="info-bar">
					<div className="info-bar-content">
						{upcomingEvents.length > 0 ? (
							Array.from({ length: 6 }).map((_, index) => {
								const event = upcomingEvents[index % upcomingEvents.length];
								const startDate = parseISO(event.EventStartDate);
								const endDate = parseISO(event.EventEndDate);
								const year = format(startDate, "yyyy");
								const startDayMonth = format(startDate, "dd MMM");
								const endDayMonth = format(endDate, "dd MMM");

								return (
									<span key={`${event.Event_ID}-${index}`}>
										{event.EventName.replace(` - ${year}`, "")} - {startDayMonth} - {endDayMonth} {year} {event.EventShortDescription}
									</span>
								);
							})
						) : (
							<span>We don't have any upcoming events right now - stay tuned for updates!</span>
						)}
					</div>
				</div>

				<nav className="navbar-layer-2 navbar navbar-expand-xl navbar-dark shadow-sm">
					<div className="container-fluid navbar-inner" >
						<div className="logo-center">
							<Link to="/">
								<img
									src="/assets/images/Logo/Logo.png"
									alt="Logo"
									height="35"
									className="header-logo"
								/>
							</Link>
						</div>

						<div className="right-content">
							{isLoggedIn ? (
								<div className="header-icon ">
									<Link
										to="/enquiry"
										className="auth-link-login enquiry-link text-white text-decoration-none"
										style={{ position: "relative" }}
									>
										<img
											src={ isMobile ? "/assets/images/Home/enquiry5.png" : "/assets/images/Home/enquiry.png" 											}
											alt="Enquiry Icon"
											className="enquiry-header-img"
										/>

										{enquiryCount > 0 && (
											<span className="enquiry-count">{enquiryCount}</span>
										)}
									</Link>
									<Link
										to="/add-to-cart"
										className="auth-link-login text-white text-decoration-none"
										style={{ position: "relative" }}
									>
										<img
											src="/assets/images/Home/trolley.png"
											alt="Cart Icon"
											style={{ width: "25px", height: "80px", objectFit: "contain" }}
											className="text-white"
										/>

										{cartCount > 0 && (
											<span className="cart-count">
												{cartCount}
											</span>
										)}
									</Link>
									<div className="position-relative">
										<div
											ref={triggerRef}
											className="d-flex align-items-center user-profile-trigger"
											onClick={() => setShowLogoutDropdown(!showLogoutDropdown)}
											style={{ cursor: "pointer" }}
										>
											<div className="user-details m-2">
												<span className="user-name text-capitalize">
													{(user?.USERNAME?.toString().toUpperCase()) || "User Name"}
												</span>
											</div>
											<UserProfileIcon userName={user?.USERNAME} />

											{/*<img*/}
											{/*	id="UserProfileIcon"*/}

											{/*	src="/assets/images/Home/account.png"*/}
											{/*	alt="User Profile"*/}
											{/*	style={{*/}
											{/*		width: "40px",*/}
											{/*		height: "40px",*/}
											{/*		borderRadius: "50%",*/}
											{/*		objectFit: "cover",*/}
											{/*	}}*/}
											{/*/>*/}
										</div>
										<div ref={dropdownRef} className={`custom-dropdown ${showLogoutDropdown ? "show" : ""}`} >										
											<button
												className={`dropdown-item fw-semibold d-flex align-items-center gap-2
													${location.pathname === "/user-profile" ? "active" : ""}`}
												onClick={() => navigate("/user-profile")}
											>
												<img src="/assets/images/Home/userIcon.png" className="dropdown-icon-img" />
												<span>Profile</span>
											</button>

											<button
												className="dropdown-item fw-semibold d-flex align-items-center gap-2"
												onClick={() => setShowLogoutModal(true)} 
											>
												<img src="/assets/images/Home/logoutIcon.png" className="dropdown-icon-img" />
												<span>Logout</span>
											</button>
										</div>
									</div>
								</div>
							) : (
								<div className="text-white fw-semibold d-flex align-items-center">
									<div className="d-flex align-items-center">
										<Link>
											<img
												ref={guestTriggerRef}
												src="/assets/images/Home/account.png"
												alt="account"
												onClick={() => setOpen(!open)}
												style={{
													width: "40px",
													height: "40px",
													objectFit: "contain",
													position: "relative",
													cursor: "pointer"
												}}
											/>
										</Link>
										<div
											ref={guestDropdownRef}
											className={`custom-dropdown ${open ? "show" : ""}`}
										>
											<button
												className={`dropdown-item fw-semibold d-flex align-items-center gap-2
													${location.pathname === "/login" ? "active" : ""}`}
												onClick={() => {
													setOpen(false);
													navigate("/login");
												}}
											>
												<img
													src="/assets/images/Home/loginIcon.png"
													className="dropdown-icon-img"
												/>
												<span>Login</span>
											</button>

											<button
												className={`dropdown-item fw-semibold d-flex align-items-center gap-2
													${location.pathname === "/register" ? "active" : ""}`}
												onClick={() => {
													setOpen(false);
													navigate("/register");
												}}
											>
												<img
													src="/assets/images/Home/registerIcon.png"
													className="dropdown-icon-img"
												/>
												<span>Register</span>
											</button>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</nav>

				<div
					className="navbar-layer-3 border-top border-bottom position-relative bg-light-new"
					style={{ minHeight: "50px" }}
				>
					<div className="container position-relative">
						<button
							className="navbar-toggler position-absolute d-md-none"
							type="button"
							onClick={toggleSubNav}
							aria-expanded={isSubNavOpen}
							aria-label="Toggle navigation"
							style={{ left: "15px", top: "12px", border: "none" }}
						>
							<i className="bx bx-list-ul" style={{ fontSize: "25px" }}></i>
						</button>

						<div
							className={`${isSubNavOpen ? "show" : ""} collapse navbar-collapse subnav-transition navbar-itemlink-text d-md-block`}
							id="subNavbar"
						>
							<ul className="navbar-nav d-flex flex-column flex-md-row flex-wrap justify-content-center py-1">
								{navItems.map((item) => (
									<li key={item.to} className="nav-item mx-2 my-1 my-md-0">
										<Link
											className={`nav-link text-center text-md-start  text-capitalize ${location.pathname.startsWith(item.to) ? "active" : ""}`}
											to={item.to}
											onClick={closeSubNav}
										>
											{item.label}
										</Link>
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</header>
			<div style={{ height: "120px" }}></div>
			<CommonPopUpModal
				isOpen={showLogoutModal}
				onClose={() => setShowLogoutModal(false)}
				onConfirm={handleLogout}
				pageType="logout"
				message="You can always log back in any time."
			/>
		</>
	);
}
